import { RoleType } from "graphql/types/AccountType";
import { t } from "../i18n";

interface RoleOption {
    value: RoleType | 'all';
    label: string;
}

export const ROLE_OPTIONS: RoleOption[] = [
    { value: 'all', label: t('enum.role.all') },
    { value: 'DSP_MANAGER', label: t('enum.role.DSP_MANAGER') },
    { value: 'DSP_OWNER_TEAM', label: t('enum.role.DSP_OWNER_TEAM') },
    { value: 'HUB_MANAGER', label: t('enum.role.HUB_MANAGER') },
    { value: 'HUB_OPERATOR', label: t('enum.role.HUB_OPERATOR') },
    { value: 'SORTING_STAFF', label: t('enum.role.SORTING_STAFF') },
    { value: 'SORTER_OPERATOR', label: t('enum.role.SORTER_OPERATOR') },
    { value: 'RETURNS_STAFF', label: t('enum.role.RETURNS_STAFF') },
    { value: 'WAREHOUSE_TAG_SORTER', label: t('enum.role.WAREHOUSE_TAG_SORTER') },
    { value: 'PICKUP_STAFF', label: t('enum.role.PICKUP_STAFF') },
    { value: 'PICKUP_DISPATCHER', label: t('enum.role.PICKUP_DISPATCHER') },
    { value: 'PICKUP_DRIVER', label: t('enum.role.PICKUP_DRIVER') },
    { value: 'WAREHOUSE_MANAGER', label: t('enum.role.WAREHOUSE_MANAGER') },
    { value: 'HEADQUARTERS_STAFF', label: t('enum.role.HEADQUARTERS_STAFF') },
    { value: 'HEADQUARTERS_ADMIN', label: t('enum.role.HEADQUARTERS_ADMIN') },
    { value: 'KAQC', label: t('enum.role.KAQC') },
    { value: 'FINANCIAL_TEAM', label: t('enum.role.FINANCIAL_TEAM') },
    { value: 'DSP_FINANCIAL_TEAM', label: t('enum.role.DSP_FINANCIAL_TEAM') },
    { value: 'INCOME_FINANCIAL_TEAM', label: t('enum.role.INCOME_FINANCIAL_TEAM') },
    { value: 'CS', label: t('enum.role.CS') },
    { value: 'CS_FOLLOW_UP', label: t('enum.role.CS_FOLLOW_UP') },
    { value: 'TMS_DISPATCHER', label: t('enum.role.TMS_DISPATCHER') },
    { value: 'TMS_DRIVER', label: t('enum.role.TMS_DRIVER') },
    { value: 'CONFIG_ADMIN', label: t('enum.role.CONFIG_ADMIN') },
    { value: 'RISK_CONTROL', label: t('enum.role.RISK_CONTROL') }
];